/**
 * The conduite module's paths.
 *
 * `/driving` is the classement, `/driving/drivers/:driverId` is one person's page and
 * `/driving/weights` is the formula configuration. The period travels in the QUERY
 * STRING for the reason the trips and fuel modules give: the URL a manager pastes into
 * a coaching note then carries the whole question — this driver, this week — and
 * reproduces exactly, including for the person disputing it.
 *
 * Route paths stay in English while the UI defaults to French. A localized URL set
 * would mean two routing tables and a redirect on every language switch; the address
 * bar is not a translated surface.
 *
 * Registration lives in `routes/app-routes.tsx`, which this phase does not own — see
 * NOTES-PHASE6-WEB.md §1 for the exact patch.
 */

export const DRIVING_PATH = '/driving'
export const DRIVER_SCORE_PATH = '/driving/drivers/:driverId'
export const SCORING_WEIGHTS_PATH = '/driving/weights'

export const DRIVING_QUERY_KEYS = {
  /** `day` | `week` | `month`. Absent means the API's default, which is `week`. */
  period: 'period',
  /** Narrows the event table and the heat map to one factor. */
  type: 'type',
} as const

export interface DrivingLinkParams {
  period?: string
  type?: string
}

function withParams(base: string, params: DrivingLinkParams): string {
  const search = new URLSearchParams()
  if (params.period) search.set(DRIVING_QUERY_KEYS.period, params.period)
  if (params.type) search.set(DRIVING_QUERY_KEYS.type, params.type)
  const query = search.toString()
  return query.length > 0 ? `${base}?${query}` : base
}

export function leaderboardPath(params: DrivingLinkParams = {}): string {
  return withParams(DRIVING_PATH, params)
}

export function driverScorePath(driverId: string, params: DrivingLinkParams = {}): string {
  return withParams(`/driving/drivers/${driverId}`, params)
}

export function scoringWeightsPath(): string {
  return SCORING_WEIGHTS_PATH
}
